/**
 * Invite and Waitlists on the phone website (`/invite`, `/waitlists`; web-account-pages D8, D10;
 * phone-signed-in/invite.html and waitlists.html): the app's Coming soon page, its header and its
 * card with the app's words naming the studio, in the app's shell (PhoneTabsLayout), its header in
 * the frame's header slot. Back returns Home, as in the app. Display only, so a visitor who opens
 * the address sees it too.
 */
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ComingSoonCard, ComingSoonHeader } from '@/pages/client/ComingSoonPage';
import { inviteCopy } from '@/pages/client/InvitePage';
import { waitlistsCopy } from '@/pages/placeholders/WaitlistsPage';

import { useSiteStudio } from '../api/site';
import { usePhoneTabsContext } from './PhoneTabsLayout';

export const COMING_SOON = {
  invite: { title: 'Invite', testId: 'invite-page', copy: inviteCopy },
  waitlists: { title: 'Waitlists', testId: 'waitlists-page', copy: waitlistsCopy },
} as const;

export function PhoneComingSoon({ screen }: { screen: keyof typeof COMING_SOON }) {
  const navigate = useNavigate();
  const studio = useSiteStudio().data;
  const { title, testId, copy } = COMING_SOON[screen];
  const { setHeaderSlot } = usePhoneTabsContext();
  useLayoutEffect(() => {
    setHeaderSlot(<ComingSoonHeader title={title} onBack={() => navigate('/')} />);
    return () => setHeaderSlot(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- re-set when the page changes only
  }, [setHeaderSlot, title]);
  return studio ? <ComingSoonCard copy={copy(studio.name)} testId={testId} /> : null;
}
